var defaultStyles = {
  "root": "Base-Tabs",
  "tabslist": "Base-Tabs--Tabslist",
  "title": "Base-Tabs--Title",
  "title_disabled": "Base-Tabs--TitleDisabled",
  "line": "Base-Tabs--Line",
  "tabs_header_title_disabled": "Base-Tabs--TabsHeaderTitleDisabled",
  "title_active": "Base-Tabs--TitleActive",
  "card": "Base-Tabs--Card",
  "card_gutter": "Base-Tabs--CardGutter",
  "tabslist_wrap": "Base-Tabs--TabslistWrap",
  "horizontal": "Base-Tabs--Horizontal",
  "vertical": "Base-Tabs--Vertical",
  "top": "Base-Tabs--Top",
  "left": "Base-Tabs--Left",
  "right": "Base-Tabs--Right",
  "animated_line": "Base-Tabs--AnimatedLine",
  "panel": "Base-Tabs--Panel",
  "panel_card": "Base-Tabs--PanelCard",
  "tabs_content_item": "Base-Tabs--TabsContentItem",
  "panel_active": "Base-Tabs--PanelActive"
};

export { defaultStyles as default };
